// Catálogo de variáveis dinâmicas da FAQ (perguntas/respostas).
// O texto é armazenado com o token cru (ex.: {{percentualIncentivo}}) e resolvido
// no backend, por campanha, na hora do consumo (doador/agente) — ver FaqVariableResolver.
// Mantenha em sincronia com auc.Helper/Faq/FaqVariableResolver.cs (KnownTokens).
export const FaqDynamicVariables = [
  {
    token: "{{percentualIncentivo}}",
    label: "Percentual de incentivo",
    hint: "Renderiza o % da campanha (ex.: 6% ou 7%), conforme o SimulatorPercentage."
  }
];

export default FaqDynamicVariables;
